/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_TabInputs */



/**
* | output |
* | --- |
* | "Support" |
*
* @param {Support_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const support_tab = /** @type {((inputs?: Support_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Soutien")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unterstützung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Supporto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поддерживать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Apoyo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("支持")
	if (locale === "ja") return /** @type {LocalizedString} */ ("サポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सहायता")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Apoiar")
	return /** @type {LocalizedString} */ ("Support")
});